import { faClipboardCheck, faCheckCircle, faUserCheck, faUserGraduate, faTimesCircle, faUsers, faUniversity, faPlay } from '@fortawesome/free-solid-svg-icons'
import React, { useEffect } from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import StatsCard from '../../component/Cards/StatsCard'
import StatsCardWithProgress from '../../component/Cards/StatsCardWithProgress'
import DonutChart, { ChartDataItem } from '../../component/Charts/DonutChart'
import { NoDataView } from '../Attendance/VenueWiseReport'
import { ClientService } from '../../component/services/client.service'
import CetLoader from '../../component/Loader/CetLoader'

interface IReverificationsOverview {
    data: any,
    chartData:any
    loading: boolean
}

export default function ReverificationOverview({data, chartData, loading}: IReverificationsOverview) {

    // const [loading, setLoading] = React.useState<boolean>(false);
    // const [data, setData] = React.useState<any>(null);
    // const [chartData, setChartData] = React.useState<ChartDataItem[]>([]);
   
    // async function getBasicStats() {
    //     setLoading(true);
    //     await ClientService.getReverificationStats()
    //         .then((res: any) => {
    //             if (res.status === 200) {
    //                 const statsData = res.data?.data || {};
    //                 setData(statsData);

    //                 const verifiedStudents = statsData.successCount || 0;
    //                 const totalStudents = statsData.assignedStudents || 0;
    //                 const notVerifiedStudents = totalStudents - verifiedStudents;

    //                 const newChartData: ChartDataItem[] = [
    //                     {
    //                         category: "Verified",
    //                         value: verifiedStudents,
    //                         fill: "#28a745"
    //                     },
    //                     {
    //                         category: "Not Verified",
    //                         value: notVerifiedStudents,
    //                         fill: "#6c757d"
    //                     }
    //                 ];
    //                 setChartData(newChartData);
    //             } else {
    //                 console.error("Failed to fetch stats:", res);
    //             }
    //         })
    //         .catch((error: any) => {
    //             console.error("Error fetching stats:", error);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }

    // useEffect(() => {
    //     getBasicStats();
    // }, []);
    return (
        <>
            {
                loading ? (
                    <div className="mt-3">
                        <CetLoader />
                    </div>
                ) : (
                    <>
                        <Card
                            className="mt-4 shadow"
                            style={{
                                borderRadius: "16px",
                                border: "1px solid #e9ecef",
                            }}
                        >
                            <Card.Body className="p-4">
                                <h5 className="text-secondary fw-bold mb-4" style={{ fontSize: '18px' }}>
                                    Reverification Overview
                                </h5>

                                <Row>
                                    <Col md={6}>
                                        {chartData.length > 0 && data ? (
                                            <DonutChart
                                                data={chartData}
                                                centerText={{
                                                    label: "Assigned Students",
                                                    value: data?.assignedStudents || 0
                                                }}
                                                height={350}
                                                width={350}
                                                showTooltip={true}
                                                showLegend={true}
                                                showCalloutLabels={true}
                                            />
                                        ) : (
                                            <NoDataView message="No reverification data available." />
                                        )}
                                    </Col>
                                    <Col md={6}>
                                        {data ? (
                                            <Row className="g-3">
                                                <Col md={12}>
                                                    {/* <StatsCard
                                                        title="Total Students"
                                                        value={data?.assignedStudents || 0}
                                                        icon={faUserGraduate}
                                                        iconColor="primary"
                                                        valueColor="info"
                                                    /> */}
                                                    <StatsCard
                                                        title="Total Colleges"
                                                        value={data?.uniqueColleges || 0}
                                                        icon={faUniversity}
                                                        iconColor="secondary"
                                                        valueColor="secondary"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCard
                                                        title="Verified Students"
                                                        value={data?.uniqueVerifications || 0}
                                                        icon={faCheckCircle}
                                                        iconColor="success"
                                                        valueColor="success"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCardWithProgress
                                                        title="Verification Rate"
                                                        value={`${((data?.uniqueVerifications || 0) / (data?.assignedStudents || 1) * 100).toFixed(1)}%`}
                                                        progress={(data?.uniqueVerifications || 0) / (data?.assignedStudents || 1) * 100}
                                                        icon={faUserCheck}
                                                        iconColor="success"
                                                        valueColor="success"
                                                    />
                                                </Col>
                                            </Row>
                                        ) : (
                                            <NoDataView message="No reverification data available." />
                                        )}
                                    </Col>
                                </Row>
                                {/* <Row className="mt-4 g-3"> */}
                                    {/* <Col md={6}>
                                        <StatsCard
                                            title="Total Verification"
                                            value={data?.totalCount || 0}
                                            icon={faUserGraduate}
                                            iconColor="info"
                                            valueColor="info"
                                        />
                                    </Col> */}
                                    {/* <Col md={6}>
                                        <StatsCard
                                            title="Unique Verifications"
                                            value={data?.uniqueVerifications || 0}
                                            icon={faUsers}
                                            iconColor="warning"
                                            valueColor="warning"
                                        />
                                    </Col> */}
                                    {/* <Col md={6}>
                                        <StatsCard
                                            title="Total Colleges"
                                            value={data?.uniqueColleges || 0}
                                            icon={faUniversity}
                                            iconColor="secondary"
                                            valueColor="secondary"
                                        />
                                    </Col> */}
                                {/* </Row> */}
                            </Card.Body>
                        </Card>
                    </>
                )
            }
        </>
    )
}